import React from 'react';
import PropTypes from 'prop-types';

import chroma from 'chroma-js';
import Helmet from 'react-helmet';
import {ease} from 'ease-tween';
import crc32 from 'lighter-crc32';

import HexGrid from '../components/HexGrid';
import Link from '../components/Link';

import greyTexture from './greytexture.png';

import './index.css';

const LINK_SATURATION = 90;
const LINK_LIGHTNESS = 55;

function mod(a, n) {
	return a - floor(a / n) * n;
}

function getLinkColour(hue) {
	return chroma.hcl(hue, LINK_SATURATION, LINK_LIGHTNESS);
}

export default class TemplateWrapper extends React.Component {
	static propTypes = {
		children: PropTypes.func.isRequired,
		location: PropTypes.object.isRequired,
	}

	constructor(props) {
		super(props);
		this.state = {
			hueSpan: 0,
			saturation: 0,
			saturationSpan: 0,
			lightness: 18,
			lightnessSpan: 8,
		};
		this.state.linkColour = getLinkColour((this.getHue() + 180) % 360);
	}

	getHue(props = this.props) {
		return crc32('salt-0' + props.location.pathname) % 360;
	}

	componentDidMount() {
		setTimeout(() => {
			this.setState({
				hueSpan: 30,
				saturation: 70,
				saturationSpan: 25,
				lightness: 20,
				lightnessSpan: 10,
			});
			setTimeout(() => {
				this.setState({
					lightness: 30,
					lightnessSpan: 20,
				});
				setTimeout(() => {
					this.setState({
						lightness: 55,
						lightnessSpan: 30,
					});
				}, 1e3);
			}, 1e3);
		}, 0.3e3);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			linkColour: getLinkColour((this.getHue(nextProps) + 180) % 360),
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			// Cancel existing animation
			if (this.transitionAnimation) {
				window.cancelAnimationFrame(this.transitionAnimation);
			}

			// Current and target hues
			const startColour = getLinkColour((this.getHue(prevProps) + 180) % 360);
			const targetHue = (this.getHue() + 180) % 360;
			const targetColour = getLinkColour(targetHue);

			// Animate
			const startTime = window.performance.now();
			const total = 1e3;
			const animate = (time) => {
				const pos = ease((time - startTime) / total);
				this.setState({
					linkColour: chroma.mix(startColour, targetColour, pos, 'lab'),
				});
				if (pos < 1) {
					this.transitionAnimation = window.requestAnimationFrame(animate);
				}
			};
			this.transitionAnimation = window.requestAnimationFrame(animate);
		}
	}

	render() {
		const {
			children,
		} = this.props;

		return (
			<div>
				<Helmet defaultTitle="Bart Nagel – web developer" titleTemplate="%s | Bart Nagel – web developer" />
				<style
					dangerouslySetInnerHTML={{__html: `
						a {
							text-decoration-color: ${this.state.linkColour.hex()};
						}
						.accent {
							color: ${this.state.linkColour.hex()};
						}
					`.replace(/\s+/g, ' ')}}
				/>
				<div className="mainContainer">
					<div className="hexGridContainer">
						<HexGrid
							hue={this.getHue()}
							hueSpan={this.state.hueSpan}
							saturation={this.state.saturation}
							saturationSpan={this.state.saturationSpan}
							lightness={this.state.lightness}
							lightnessSpan={this.state.lightnessSpan}
							className="hexGrid"
						/>
					</div>
					<div className="mainArea">
						{children()}
						<footer>
							<p>
								© Bart Nagel, 2003–2026
							</p>
						</footer>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/layouts/index.js